import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Das Cranach Design unterstüttzt Beteiligte des Cranach Digital Archives bei der Erstellung der UI, alle Fragen bezüglich des Designs des Cranach Digital Archives beantwortet werden.`}</p>
    </PageDescription>
    <p>{`Das Cranach Design ermöglicht es Informationen bezüglich des Cranach Digital Archivs und digitale Designressourcen bereitzustellen. Aufgrund des frühen Zustand des Design Systems werden vorrangig Entwickler-Ressourcen bereitsgestellt, die für das Testen des Cranach Designs benätigt werden. Grundlegend werden hierbei UI-Pattern und Styling-Elemente zur Verfügung gestellt, die über den Packagemanager NPM installiert werden können.`}</p>
    <p>{`Erfahre mehr über die Integration von Designressourcen:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../developing/overview"
        }}>{`Mehr zu der Integration von React Pattern`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../guidelines/color"
        }}>{`Mehr zu der Integration von Farben`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../guidelines/typographie"
        }}>{`Mehr zu der Integration von Typographien`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      